require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tankeexperiment-i-fysiken.json") })
        }
      }, "path---tankeexperiment-i-fysiken");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tankeexperiment-i-fysiken!./.cache/json/tankeexperiment-i-fysiken.json
// module id = 492
// module chunks = 231608221292675